<!-- gmail-non-eu-mobile-03 preview — a single real state: an inbox row with an
     inline creative thumbnail beneath the sponsored/headline/description text,
     unlike mobile-1/mobile-2 whose collapsed rows carry no thumbnail. This set
     has no separate expanded-message state. -->
<app-mobile-frame>
  <!-- START: Gmail inbox top bar — pinned above the inbox list -->
  <div frameTop class="gm-inbox-topbar">
    <div class="gm-inbox-searchbar d-flex flex-row align-items-center justify-content-between">
      <i class="bi bi-list gm-inbox-icon"></i>
      <span class="gm-inbox-avatar placeholder"></span>
    </div>
  </div>
  <!-- END: Gmail inbox top bar -->

  <!-- START: Inbox list -->
  <div class="gm-inbox">
    <div class="gm-inbox-tabs">
      <span class="gm-inbox-tab-bar placeholder"></span>
    </div>

    <!-- START: Real ad -->
    <div class="gm-inbox-ad">
      <div class="gm-inbox-ad-row d-flex flex-row">
        <img *ngIf="data.logo" class="gm-inbox-logo" [src]="data.logo" alt="" />
        <span *ngIf="!data.logo" class="gm-inbox-logo logo-empty" aria-hidden="true"></span>

        <div class="gm-inbox-copy">
          <div class="gm-inbox-line1">
            <span class="gm-inbox-sponsored">Sponsored</span> ·
            <span class="gm-inbox-sender">Valamar</span>
          </div>
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gm-inbox-headline">
            {{ data.headlines[0] || "Your headline appears here" }}
          </a>
          <div class="gm-inbox-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>
        </div>

        <i class="bi bi-box-arrow-up-right gm-inbox-external"></i>
      </div>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gm-inbox-thumb-link">
        <img *ngIf="creativeImage" class="gm-inbox-thumb" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="gm-inbox-thumb creative-missing">{{ missingDimensionLabel }}</div>
      </a>
    </div>
    <!-- END: Real ad -->

    <!-- Rest of the inbox, skeleton filler -->
    <div class="gm-inbox-row d-flex flex-row" *ngFor="let row of inboxSkeletonRows">
      <span class="gm-inbox-row-avatar placeholder"></span>
      <div class="gm-inbox-row-lines d-flex flex-column">
        <span class="gm-inbox-row-bar placeholder"></span>
        <span class="gm-inbox-row-bar gm-inbox-row-bar-short placeholder"></span>
      </div>
    </div>
  </div>
  <!-- END: Inbox list -->

  <!-- START: Gmail bottom nav — pinned below the inbox list -->
  <div
    frameBottom
    class="gm-inbox-bottomnav d-flex flex-row justify-content-around align-items-center"
  >
    <span class="gm-inbox-bottomnav-btn">
      <i class="bi bi-envelope-fill"></i>
    </span>
    <i class="bi bi-chat-dots gm-inbox-bottomnav-icon"></i>
    <i class="bi bi-camera-video gm-inbox-bottomnav-icon"></i>
  </div>
  <!-- END: Gmail bottom nav -->
</app-mobile-frame>
